import { Item, Root } from '@radix-ui/react-accordion';
import { useMemo } from 'react';
import { ScommesseAccordionContent, ScommesseAccordionContentType } from './scommesseAccordionContent';
import classNames from 'classnames';
import { ItemWithTranslation } from 'types/swagger';
import styles from './ScommesseAccordion.module.scss';
import { ScommesseAccordionTrigger } from './scommesseAccordionTrigger';

export type ScommesseAccordionProps = ItemWithTranslation<{ text?: string }> & {
  children: React.ReactNode;
  allOpened?: boolean | undefined;
  isVirtual?: boolean;
  defaultOpened?: string;
  avvenimentoKey?: string;
  isTooltipClicked?: boolean;
  isVisualizzazioneEstesa?: boolean;
  infoTipoScommessaKeyStringList?: Array<string>;
  rootClassName?: string;
};

export function ScommesseAccordion({
  text,
  children,
  textTrKey,
  allOpened,
  isVirtual,
  rootClassName,
  defaultOpened,
  avvenimentoKey,
  isTooltipClicked,
  childrenClassName,
  containerClassName,
  isVisualizzazioneEstesa,
  infoTipoScommessaKeyStringList,
}: ScommesseAccordionProps &
  Pick<ScommesseAccordionContentType, 'childrenClassName' | 'containerClassName'>): JSX.Element {
  const options = useMemo(() => {
    const result = {};
    if (allOpened) {
      Reflect.set(result, 'defaultValue', [text ?? '']);
    } else {
      Reflect.set(result, 'collapsible', true);
      Reflect.set(result, 'defaultValue', defaultOpened);
    }

    Reflect.set(
      result,
      'className',
      classNames(styles.container, rootClassName, { [styles.isClickedInside]: isTooltipClicked })
    );

    return result;
  }, [allOpened, defaultOpened, isTooltipClicked, rootClassName, text]);

  return (
    <Root {...options} type={allOpened ? 'multiple' : 'single'}>
      <Item value={text ?? ''} className={styles.item}>
        <ScommesseAccordionTrigger
          text={text ?? ''}
          textTrKey={textTrKey}
          avvenimentoKey={avvenimentoKey}
          infoTipoScommessaKeyStringList={infoTipoScommessaKeyStringList}
        />
        <ScommesseAccordionContent
          isVirtual={isVirtual}
          childrenClassName={childrenClassName}
          containerClassName={containerClassName}
          isVisualizzazioneEstesa={isVisualizzazioneEstesa}
        >
          {children}
        </ScommesseAccordionContent>
      </Item>
    </Root>
  );
}
